import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from '@emotion/styled';

import {
  getAuthError,
  getSubmitting,
  getUserId,
  getBrand,
} from 'data_system/token_auth/selectors';

import WarningIcon from 'views/ui/icons/Warning';
import { login } from 'data_system/token_auth/actions';
import { t } from 'services/translation';
import { Theme } from 'ui_system/theme';
import { titleize } from 'lib/string_utils';
import { Button } from './elements/Button';
import { AccessibleCheckbox } from './elements/Checkbox';
import { FormFooter } from './FormFooter';
import {
  Label,
  Input,
  Heading,
  Form,
  FormContainer,
  Error as Err,
  InputSection,
  Link,
  LoginOptions,
} from './styles_auth';
import { RESET_PASSWORD_REQUEST, SIGNUP_REQUEST } from './routes';

const EmailLabel = styled(Label)`
  margin-top: 20px;
`;

const ErrorMessage = styled.div`
  column-gap: 8px;
  display: grid;
  grid-template-columns: 16px 300px;
`;

const Error = styled(Err)`
  padding: 0;
`;

const ErrorIcon = styled(WarningIcon)`
  fill: ${Theme.colors.red};
  height: 16px;
  width: 16px;
`;

const LoginPage = ({ userName, signupRequest }) => {
  const dispatch = useDispatch();
  const [email, setEmail] = useState(localStorage.getItem('email') || '');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(
    Boolean(localStorage.getItem('email'))
  );

  const userId = useSelector(getUserId);
  const { name } = useSelector(getBrand);
  const error = useSelector(getAuthError);
  const submitting = useSelector(getSubmitting);

  useEffect(() => {
    document.title = `${name} - ${t('LOG_IN')}`;
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(login({ email, rememberMe, uid: `${email}+${userId}`, password }));
  };

  return (
    <FormContainer>
      {userName && <Heading>{userName}</Heading>}
      <Heading bold>{t('LOG_IN')}</Heading>

      <Form onSubmit={handleSubmit}>
        {error ? (
          <ErrorMessage>
            <ErrorIcon />
            <Error>{t(error)}</Error>
          </ErrorMessage>
        ) : null}
        <EmailLabel>{titleize(t('EMAIL_ADDRESS'))}</EmailLabel>
        <InputSection>
          <Input
            data-testid="login-email"
            type="text"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </InputSection>
        <Label>{t('PASSWORD')}</Label>
        <InputSection>
          <Input
            data-testid="login-password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </InputSection>

        <LoginOptions>
          <AccessibleCheckbox
            checked={rememberMe}
            onChange={() => setRememberMe(!rememberMe)}
          >
            {t('REMEMBER_ME')}
          </AccessibleCheckbox>

          <Link to={RESET_PASSWORD_REQUEST}>{t('FORGOT_YOUR_PASSWORD')}</Link>
        </LoginOptions>
        <Button disabled={submitting} text={t('LOG_IN')} />
      </Form>

      {signupRequest && (
        <div style={{ width: '100%', textAlign: 'center' }}>
          <Link to={SIGNUP_REQUEST} margin="30px ">
            {t('HAVEN_T_REGISTERED_YET')}
          </Link>
        </div>
      )}

      <FormFooter />
    </FormContainer>
  );
};

export default LoginPage;
